import { axiosInstance } from "../../Authentication/AxiosInterceptor";
import { LibraryLiteCutoffListDto } from "../../Types/LibraryLite/LibraryLiteCutoff";

export const getLibraryLiteCutoffs = async (params: {
  q?: string;
  page: number;
  pageSize: number;
}): Promise<LibraryLiteCutoffListDto> => {
  const response = await axiosInstance.get("LibraryLite/Cutoffs", { params });
  return response.data;
};

export const updateLibraryLiteCutoff = async (
  clientId: string,
  cutoffDate: string | null
): Promise<void> => {
  await axiosInstance.post("UpdateLibraryLiteCutoff", { clientId, cutoffDate });
};
